<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Produtos</h1>
    <button class="btn btn-primary" (click)="novoProduto()">Incluir Novo Produto</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por Nome do Produto..." [(ngModel)]="searchTerm" (input)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Nome do Produto</th>
          <th scope="col">Descrição</th>
          <th scope="col">Tipo</th>
          <th scope="col">Codigo NCM</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let produto of paginatedProdutos">
          <th scope="row">{{ produto.id }}</th>
          <td>{{ produto.nomeProduto }}</td>
          <td>{{ produto.descricao }}</td>
          <td>{{ produto.tipo }}</td>
          <td>{{ produto.ncm.codigo }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm me-2" (click)="editarProduto(produto.id)">Editar</button>
            <button type="button" class="btn btn-success btn-sm me-2" (click)="definirPreco(produto.id)">Preço</button>
          </td>
        </tr>
        <tr *ngIf="paginatedProdutos.length === 0">
          <td colspan="6" class="text-center text-muted py-4">Nenhum produto encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(1)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages)">Última</a>
      </li>
    </ul>
  </nav>
</div>
